import React, { Suspense } from 'react';
import './style.scss';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { logout } from 'stores/User/userActions';
import { urlFormatter } from '../../../../util';
import { Link } from 'react-router-dom';

import Translation from 'services/translation.service';
import Logout from 'components/ui_elements/Icons/Logout';
import LogOutIcon from '../../../../assets/img/icon/Log in.svg';

const MenuFooter = ({ logout, opened, links, loggedIn, hideSideMenu }) => {
  const menuFooter = ['menuFooter'];
  if (opened) {
    menuFooter.push('opened');
  }

  const loginLink =
    urlFormatter(links?.['informative-login']?.['route']) ||
    urlFormatter(links?.['informative-login']?.[1]?.['route']);

  return (
    <div className={menuFooter.join(' ')}>
      {!loggedIn ? (
        <Link to={loginLink} className="logoutBtnMnu" onClick={hideSideMenu}>
          <img src={LogOutIcon} />
          &nbsp;
          <span>{Translation.key('profile_scrn_lbl1.11_login')}</span>
        </Link>
      ) : (
        <div
          className="logoutBtnMnu"
          onClick={() =>
            logout(urlFormatter(links['informative-login']['route']).substr(1))
          }
        >
          <img loading="lazy" src={LogOutIcon} />
          &nbsp;
          <span>{Translation.key('profile_scrn_lbl1.11_logout')}</span>
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    loggedIn: state.user.loggedIn,
    subscribersList: state.user.subscribersList,
    selectedSubscriber: state.user.selectedSubscriber,
    links: state.layout.routes,
  };
};
const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ logout }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(MenuFooter);
